<template>
    <div id="exportable-content">
        <Hero title="GDPR Data Protection Agreement Sub-Processors" colour-index="4"
            subtitle="Date of last revision: October 2, 2025" :left="true" />

        <div class="px-3 sm:px-28 sm:mb-12 text-[var(--black)]">
            <table
                class="table-auto border shadow w-full border-collapse border-spacing-2 text-sm text-left text-[var(--medium-gray)] rounded-lg"
                cellpadding="12">
                <thead>
                    <tr class="border-b">
                        <th>Provider</th>
                        <th>Location(s)</th>
                        <th>Purpose</th>
                        <th>URL</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="p of SUBPROCESSORS">
                        <td>{{ p.name }}</td>
                        <td>
                            {{ p.locations }}
                        </td>
                        <td>
                            {{ p.purpose }}
                        </td>
                        <td>
                            <a :href="p.url" target="_blank">{{ p.url }}</a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script lang="ts">
import { setTitle } from '~~/services/common';

export default {
    setup() {
        setTitle(
            'GDPR Sub-Processors',
            'List of sub-processors used by Unified.to when processing personal data on behalf of our customers.'
        );
    },
    data() {
        return {
            SUBPROCESSORS: [
                {
                    name: 'Amazon Web Services (AWS)',
                    locations: 'US, EU, AU',
                    purpose: 'Infrastructure/Hosting',
                    url: 'https://aws.amazon.com',
                },
                {
                    name: 'Render',
                    locations: 'US, EU, AU',
                    purpose: 'Infrastructure/Hosting',
                    url: 'https://render.com',
                },
                {
                    name: 'MongoDB',
                    locations: 'US, EU, AU',
                    purpose: 'Database',
                    url: 'https://www.mongodb.com',
                },
                {
                    name: 'Datadog',
                    locations: 'US',
                    purpose: 'Monitoring/Availability',
                    url: 'https://datadoghq.com',
                },
                {
                    name: 'Cloudflare',
                    locations: 'Global',
                    purpose: 'DNS',
                    url: 'https://cloudflare.com',
                },
                {
                    name: 'PostHog',
                    locations: 'US',
                    purpose: 'In-product analytics',
                    url: 'https://posthog.com',
                },
                {
                    name: 'Stripe',
                    locations: 'US',
                    purpose: 'Payment processing',
                    url: 'https://stripe.com',
                },
                {
                    name: 'Customer.io',
                    locations: 'US',
                    purpose: 'Product emails',
                    url: 'https://customer.io',
                },
                {
                    name: 'Redis',
                    locations: 'US, EU, AU',
                    purpose: 'Data optimization',
                    url: 'https://redis.io',
                },
                {
                    name: 'ClickHouse',
                    locations: 'US, EU, AU',
                    purpose: 'API call logs',
                    url: 'https://clickhouse.com',
                },
            ],
        };
    },
};
</script>
